import { CompanySelectorModalForm } from "./CompanySelectorModalForm"

const CompanySelectorFormWrapper = ({userData, onClose}: any) => {
    return (<CompanySelectorModalForm userData={userData} onClose={()=>onClose()}/>)
}

export { CompanySelectorFormWrapper }